class HomeHeaderVideo {
    constructor(videoElement) {
        this.videoElement = videoElement;
        this.videoElement.removeAttribute('loop');

        if (this.videoElement.currentTime > 0) {
            this.startTimer();
        } else {
            this.videoElement.play();
            this.videoElement.addEventListener('playing', () => this.startTimer(), true);
        }
    }

    startTimer() {
        this.timer = setInterval(this.timerTick, 25, this)
    }

    stopTimer() {
        clearInterval(this.timer);
    }

    timerTick(self) {
        if (self.videoElement.currentTime > 6.76) {
            self.videoElement.currentTime = 5.25;
            self.videoElement.play();
        }
    }
}

export const initHomeHeaderVideo = () => {
    let videoElement = document.getElementById('home-header-video');

    if (videoElement) {
        new HomeHeaderVideo(videoElement);
    }
};